<template>
    <el-popover placement="bottom-start" trigger="hover">
        <div>
            <div v-html="content"></div>
        </div>
        <div class="inline" slot="reference" @click="handleOpen">
            <slot></slot>
        </div>
    </el-popover>
</template>
<script>
export default {
    props: {
        content: {
            type: String,
            default: "",
        },
        width: {
            type: Number,
            default: 100,
        },
    },
    data() {
        return {
            visible: false,
        };
    },
    methods: {
        handleOpen() {
            this.visible = true;
        },
        close() {
            this.visible = false;
        },
    },
};
</script>
